import { useEffect, useRef, useState } from 'react'
import { ApiError, getText } from '@/lib/api'

export function usePortalActivityDownload(path: string, filename: string) {
  const active = useRef<AbortController | null>(null)
  const [pendingPath, setPendingPath] = useState<string | null>(null)
  const [failure, setFailure] = useState<{ path: string; forbidden: boolean } | null>(null)
  useEffect(() => () => active.current?.abort(), [path])
  const download = async () => {
    active.current?.abort()
    const request = new AbortController()
    active.current = request
    setPendingPath(path)
    setFailure(null)
    try {
      const csv = await getText(path, request.signal)
      if (request.signal.aborted) return
      const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      link.click()
      URL.revokeObjectURL(url)
    } catch (error) {
      if (!request.signal.aborted)
        setFailure({ path, forbidden: error instanceof ApiError && error.status === 404 })
    } finally {
      if (active.current === request) setPendingPath(null)
    }
  }
  return {
    download,
    pending: pendingPath === path,
    error: failure?.path === path,
    forbidden: failure?.path === path && failure.forbidden,
  }
}
